<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="仓库">
              <a-select
                v-model="queryParam.storeId"
                placeholder="所有仓库"
              >
                <a-select-option value="0">所有仓库</a-select-option>
                <a-select-option v-for="item in storeData" :value="item.id" :key="item.id"> {{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              label="商品类别"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-tree-select
                placeholder="请选择商品类别"
                treeDefaultExpandAll
                :treeData="categoryData"
                treeCheckable
                @change="onGoodsCatChange"
                :showCheckedStrategy="SHOW_ALL"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="商品"
            >
              <a-input-search
                placeholder="请选择商品"
                @change="goodsTextChange"
                @search="onGoodsSearch"
                @click="onGoodsSearch"
                v-model="goodsNames"
              ><a-button slot="enterButton">选择</a-button></a-input-search>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-checkbox @change="onChange" :defaultChecked="true">零库存</a-checkbox>
              <a-button type="primary" @click="tableSearch" style="margin-right: 8px">查询</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" @click="saveResult()" :loading="state.btn" :disabled="state.btn" style="margin-right: 8px">保存盘点结果</a-button>
      <a-dropdown :trigger="['click']">
        <a-menu slot="overlay">
          <a-menu-item @click="buildBill(TYPE_PANYING)">盘盈单</a-menu-item>
          <a-menu-item @click="buildBill(TYPE_PANKUI)">盘亏单</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          生成盘点单据 <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-button @click="exportExcel" style="margin-left: 8px">导出系统库存</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize="20"
      :columns="columns"
      :data="loadData"
      bordered
      rowKey="id"
    >
      <span slot="goodsCategory" slot-scope="text, record">
        <span v-if="record.goods.category">{{record.goods.category.name}}</span>
      </span>
      <span slot="pdText" slot-scope="text, record, index">
        <pd-text :rowindex="index" :value="record.pd" @inputChange="pdInputChange"></pd-text>
      </span>
      <span slot="ykText" slot-scope="text, record">
        <yk-text :num="record.num" :pd="record.pd"></yk-text>
      </span>
    </s-table>
    <GoodsModal :visible="goodsModalVisible" @handleCancel="goodsModalCancel" @handleOk="goodsModalOk"></GoodsModal>
  </a-card>
</template>
<script>
import moment from 'moment'
import STable from '@/components/table/'
import { commonStoreList } from '@/api/common'
import GoodsModal from '@/components/Goods/Modal'
import { getStorageInventory, savePdResult } from '@/api/storage'
import PdText from '@/components/Storage/PdText'
import YkText from '@/components/Storage/YkText'
import { CODE_FAIL, TYPE_PANYING, TYPE_PANKUI } from '@/store/mutation-types'
import { getCategoryGoods } from '@/api/category'
import { TreeSelect } from 'ant-design-vue'
import { downloadExcel } from '@/utils/util'
import { excelPdReport } from '@/api/excel'
const SHOW_ALL = TreeSelect.SHOW_ALL
export default {
  components: {
    STable,
    GoodsModal,
    PdText,
    YkText
  },
  data () {
    return {
      SHOW_ALL,
      TYPE_PANYING,
      TYPE_PANKUI,
      state: {
        btn: false
      },
      goodsModalVisible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      // 查询参数
      queryParam: {
        goodsIds: '',
        storeId: '0',
        pdNo: '',
        goodsCatIds: '',
        all: true
      },
      storeId: '0',
      storeData: null,
      goodsNames: '',
      storeNames: '',
      entries: null,
      pdNo: '',
      hasPd: false,
      pdModify: false,
      categoryData: null,
      // 表头
      columns: [
        {
          title: '仓库',
          dataIndex: 'store.name',
          className: 'text-center'
        },
        {
          title: '商品类别',
          dataIndex: 'goods.category.name',
          className: 'text-center',
          scopedSlots: { customRender: 'goodsCategory' }
        },
        {
          title: '商品编号',
          dataIndex: 'goods.locationNo',
          className: 'text-center'
        },
        {
          title: '商品名称',
          className: 'text-center',
          dataIndex: 'goods.name'
        },
        {
          title: '规格型号',
          className: 'text-center',
          dataIndex: 'goods.type'
        },
        {
          title: '单位',
          className: 'text-center',
          dataIndex: 'goods.unit.name'
        },
        {
          title: '系统库存',
          dataIndex: 'num',
          className: 'text-center'
        },
        {
          title: '盘点库存',
          dataIndex: 'pd',
          className: 'text-center',
          scopedSlots: { customRender: 'pdText' }
        },
        {
          title: '盘盈盘亏',
          dataIndex: 'yk',
          className: 'text-center',
          scopedSlots: { customRender: 'ykText' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getStorageInventory(Object.assign(parameter, this.queryParam))
          .then(res => {
            this.entries = res.result
            this.pdModify = false
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    console.log('是否有参数', this.$route.query)
    const query = this.$route.query
    if (query.hasOwnProperty('pdNo') && query.hasOwnProperty('storeId')) {
      this.pdNo = query.pdNo
      this.storeId = query.storeId
      this.hasPd = true
      this.queryParam.pdNo = query.pdNo
      this.queryParam.storeId = query.storeId
    }
    this.queryParam.s_date = moment().subtract(7, 'days').format(this.format)
    this.queryParam.e_date = moment().format(this.format)
    this.loadStore()
    this.loadCategory()
  },
  methods: {
    moment,
    loadStore () {
      commonStoreList({ all: true }).then(res => {
        this.storeData = res.result.data
      })
    },
    saveResult () {
      this.state.btn = true
      if (this.hasPd === false) {
        this.$message.error('请先进行盘点')
        this.state.btn = false
        return false
      }
      const saveData = Object.assign({}, { entries: this.entries.data, storeId: this.storeId, pdNo: this.pdNo })
      savePdResult(saveData).then(res => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('保存盘点结果成功！盘点编号为: ' + res.result)
          this.pdNo = res.result
          this.pdModify = false
        } else {
          this.$message.error(res.message)
        }
      }).catch(() => {
      }).finally(() => {
        this.state.btn = false
      })
    },
    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.storeId = this.queryParam.storeId
      this.pdNo = ''
      this.queryParam.pdNo = ''
      this.hasPd = false
      this.$refs.table.refresh(true)
    },
    goodsTextChange (e) {
      if (!e.data) {
        this.queryParam.goodsIds = ''
      }
    },
    goodsModalCancel () {
      this.goodsModalVisible = false
    },
    goodsModalOk (selectedRows) {
      this.goodsModalVisible = false
      if (selectedRows.length > 0) {
        const ids = []
        const names = []
        selectedRows.forEach(function (item) {
          ids.push(item.id)
          names.push(item.name)
        })
        this.queryParam.goodsIds = ids.join(',')
        this.goodsNames = names.join(',')
      }
    },
    onGoodsSearch () {
      this.goodsModalVisible = true
    },
    onChange (e) {
      if (e.target.checked) {
        this.queryParam.all = true
      } else {
        this.queryParam.all = ''
      }
    },
    pdInputChange (data) {
      if (data.value !== undefined) {
        if (this.entries.data[data.rowindex].pd !== data.value) {
          this.pdModify = true
        }
        this.entries.data[data.rowindex].pd = data.value
        this.hasPd = true
      }
      console.log(this.entries)
    },
    buildBill (type) {
      if (this.pdNo === '' || this.pdModify === true) {
        this.$message.error('请先进行盘点并保存盘点结果')
        return false
      }
      if (type === TYPE_PANYING) {
        this.$router.push({ path: '/storage/other/in', query: { pdNo: this.pdNo, transType: type } })
      } else {
        this.$router.push({ path: '/storage/other/out', query: { pdNo: this.pdNo, transType: type } })
      }
      console.log(type)
    },
    loadCategory () {
      getCategoryGoods({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    onGoodsCatChange (val) {
      this.queryParam.goodsCatIds = val.join(',')
    },
    exportExcel () {
      excelPdReport(this.queryParam).then(res => {
        downloadExcel('pdReport_' + moment().format('YYYYMMDDHHmmss'), res)
      })
    }
  },
  watch: {
    'pdNo' () {
      this.queryParam.pdNo = this.pdNo
    }
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
